<template>
  <div ref="rootRef" class="l3">
    <a class="skip" href="#contenido">Saltar al contenido</a>
    <main id="contenido">
      <section class="hero wrap" aria-labelledby="hero-title">
        <div class="hero-copy">
          <div class="eyebrow">Lo que hacés vale. Que se note.</div>
          <h1 id="hero-title">
            Tu trabajo.<br />¿Reducido a un <span class="accent">choclo de texto?</span>
          </h1>
          <p v-if="isCopyV2">
            Armá el presupuesto en Prio y compartí
            <strong>un link con tu marca</strong>: el cliente elige opcionales y aprueba online.
            Lo compartís por WhatsApp y tu cliente lo abre desde el celular. Vos consultás la
            actividad del presupuesto.
          </p>
          <p v-else>
            Así se ve hoy lo que vendés por WhatsApp. Prio lo convierte en
            <strong>un link con tu marca</strong>: el cliente elige opcionales y aprueba online. Vos
            consultás la actividad del presupuesto.
          </p>
          <a class="cta" :href="SIGNUP_URL"
            >Probá gratis 30 días <span aria-hidden="true">↗</span>
          </a>
          <div class="guarantee">Sin tarjeta</div>
        </div>
        <div class="hero-visual">
          <div id="hero-stage" class="hero-stage" :data-state="heroState">
            <div class="orbit" aria-hidden="true"></div>
            <span class="spark" aria-hidden="true">✳</span>
            <div
              id="hero-before"
              class="hero-layer chat-sheet"
              :aria-hidden="heroState !== 'before'"
            >
              <div class="chat-header"><span class="avatar">V</span>Vos · WhatsApp</div>
              <p>
                hola paula te paso proyecto de interiores 2800000 direccion de obra 2900000
                relevamiento 650000 planos 450000 computo de materiales 250000 total 7050000. aparte
                visualizacion 3d 350000 visita adicional 480000 manual 220000. anticipo 30% saldo al
                entregar valido 15 dias cualquier cosa avisame y lo vemos
              </p>
              <small>18:42 · ✓✓</small>
              <span class="chat-reply">¿La visualización 3D estaba incluida?</span>
            </div>
            <div id="hero-after" class="hero-layer hero-paper" :aria-hidden="heroState !== 'after'">
              <div class="paper">
                <div class="paper-head">
                  <span class="studio">
                    <span class="studio-icon" aria-hidden="true">✳</span>sur estudio</span
                  >
                  <span class="tag">TU MARCA</span>
                </div>
                <h3>Presupuesto</h3>
                <p class="small">Para Paula García · Nº A7K2M</p>
                <div class="line">
                  <span>Proyecto + dirección + documentación</span>
                  <b>$ 7.050.000</b>
                </div>
                <div class="line">
                  <span>✓ Visualización 3D</span>
                  <b>$ 350.000</b>
                </div>
                <div class="total">
                  <span>Total elegido</span>
                  <strong>$ 7.400.000</strong>
                </div>
                <div class="link-bar">↗ prio.ar/u/sur-estudio/p/A7K2M</div>
                <span class="floating-label">Tu trabajo, bien presentado.</span>
              </div>
            </div>
          </div>
          <div class="compare-control" role="group" aria-label="Comparar presentaciones">
            <button
              type="button"
              data-action="hero-state"
              data-context="before"
              :aria-pressed="heroState === 'before'"
              @click="setHero('before')"
            >
              Hoy, por WhatsApp
            </button>
            <button
              type="button"
              data-action="hero-state"
              data-context="after"
              :aria-pressed="heroState === 'after'"
              @click="setHero('after')"
            >
              Con Prio ↗
            </button>
          </div>
          <p class="caption mono">EL MISMO TRABAJO. OTRA FORMA DE VENDERLO.</p>
        </div>
      </section>
      <div class="bridge">
        <div class="wrap">
          <p>Para quienes cocinan, decoran, fotografían, guían, diseñan.</p>
          <span class="mono">Y COBRAN POR ESO.</span>
        </div>
      </div>
      <section class="section wrap" aria-labelledby="pain-title">
        <div class="pain-heading reveal">
          <div class="eyebrow">El costo de seguir así</div>
          <h2 id="pain-title">
            No es solo texto.<br />Es tiempo, ventas <span class="accent">y malentendidos.</span>
          </h2>
        </div>
        <div class="pain-grid">
          <article class="pain-card reveal">
            <div class="pain-stat">
              <span>↺</span>
              <small>otra vez</small>
            </div>
            <h3>Para escribir. Y reescribir.</h3>
            <p>
              Cambiás el alcance, sumás una visita. A la <span data-count="3">3</span>.ª edición, un
              precio quedó viejo. Y el que paga la diferencia sos vos.
            </p>
          </article>
          <article class="pain-card reveal">
            <div class="pain-stat">0 <small>señales</small></div>
            <h3>Mandaste. Ahora, a adivinar.</h3>
            <p>
              ¿Lo abrió? ¿Lo leyó? ¿Le cerró? No sabés si llamar o esperar. Mientras tanto, la venta
              se enfría.
            </p>
          </article>
          <article class="pain-card reveal">
            <div class="pain-stat">¿dale?</div>
            <h3>Un sí que no dice a qué.</h3>
            <p>
              Tres meses después: “Yo pensé que incluía los renders”. Volvés al chat. Y empieza la
              discusión.
            </p>
          </article>
        </div>
        <p class="pain-end reveal">
          <span>No es que te falte organización.</span> Es que tu sistema es desorganizado.
        </p>
      </section>
      <section class="value wrap" aria-label="Cinco maneras de presupuestar mejor">
        <div class="value-head">
          <div class="eyebrow">Del choclo de texto al sí</div>
          <p>Cinco diferencias.<br />{{ isCopyV2 ? 'Una propuesta más clara.' : 'Una venta más clara.' }}</p>
        </div>
        <article class="beat" id="tu-marca">
          <div class="beat-copy reveal">
            <div class="eyebrow">01 / Primero, tu marca</div>
            <h2>
              Que el precio<br />no sea lo único<br />
              <span class="accent">que se vea.</span>
            </h2>
            <p>
              Tu logo. Tu propuesta. Cada ítem en su lugar. Elegí
              <strong>un diseño profesional</strong> y mandá un link que se vea tan bien como tu
              trabajo, también en el celular.
            </p>
            <p>
              Sin PDF adjunto. Con validez de 5, 7, 15 o 30 días. Si vence, el cliente ve cómo
              contactarte. No un callejón sin salida.
            </p>
            <p class="aside">Tocá un color. Tu marca cambia de diseño, no de protagonismo.</p>
          </div>
          <div class="mock-stage reveal">
            <div class="mock-top">
              <span class="mono">ASÍ TE VE TU CLIENTE</span>
              <span>↗ prio.ar/u/sur-estudio/p/…</span>
            </div>
            <div
              id="skin-quote"
              data-context="quote-preview"
              class="skin-quote"
              :data-skin="String(skinIndex)"
              :style="skinVars"
            >
              <div class="paper-head">
                <span class="studio">
                  <span class="studio-icon" aria-hidden="true">✳</span>sur estudio</span
                >
                <span class="tag">Nº A7K2M</span>
              </div>
              <h3>Presupuesto</h3>
              <p class="small">Para Paula García</p>
              <div class="line">
                <span>Proyecto de interiores</span>
                <b>$ 2.800.000</b>
              </div>
              <div class="line">
                <span>Dirección de obra</span>
                <b>$ 2.900.000</b>
              </div>
              <div class="line">
                <span>Relevamiento + documentación</span>
                <b>$ 1.350.000</b>
              </div>
              <p id="expiry-note" class="expiry-note" aria-live="polite">{{ expiryNote }}</p>
            </div>
            <div class="skin-toolbar">
              <div class="skin-dots" role="group" aria-label="Probar seis diseños ilustrativos">
                <button
                  v-for="(dot, i) in skinDots"
                  :key="dot.label"
                  type="button"
                  data-action="quote-skin"
                  :data-context="'diseno-' + (i + 1)"
                  :data-skin="String(i)"
                  :aria-label="dot.label"
                  :aria-pressed="skinIndex === i"
                  :style="'--swatch:' + dot.swatch"
                  @click="selectSkin(i)"
                >
                  <i></i>
                </button>
              </div>
              <div class="validity">
                <label for="validity">VALIDEZ</label>
                <select
                  id="validity"
                  v-model="validity"
                  data-input="validity"
                  @change="onValidityChange"
                >
                  <option value="5">5 días</option>
                  <option value="7">7 días</option>
                  <option value="15" selected>15 días</option>
                  <option value="30">30 días</option>
                </select>
              </div>
            </div>
            <div class="expiry">
              <p>Diseños ilustrativos · Los mismos datos, distinta presentación.</p>
              <button
                id="expire"
                class="small-button"
                type="button"
                data-action="validity-expired"
                :aria-pressed="expired"
                @click="toggleExpired"
              >
                {{ expired ? 'Ver vigente' : 'Ver vencido' }}
              </button>
            </div>
          </div>
        </article>
        <article class="beat" id="armado">
          <div class="beat-copy reveal">
            <div class="eyebrow">02 / Menos tipear. Más hacer.</div>
            <h2>
              Decilo como<br />te salga.<br />
              <span v-if="isCopyV2" class="accent">Revisalo con tu criterio.</span>
              <span v-else class="accent">Revisalo como vos.</span>
            </h2>
            <p>
              Tu cliente te cuenta qué necesita. Vos se lo pasás a la IA
              <strong>por texto o voz</strong>. Usa tu catálogo y tus presupuestos anteriores como
              referencia. Vos revisás servicios e importes antes de compartir.
            </p>
            <p>
              ¿Ya lo hiciste antes? Usá una plantilla guardada.
              <strong>Ya tenés la base. Solo revisás.</strong> ¿Preferís el control total? Armalo a
              mano, ítem por ítem.
            </p>
            <p class="aside">
              Y para editar: decís el cambio, revisás qué cambia y recién ahí lo aplicás.
            </p>
          </div>
          <div class="mock-stage reveal">
            <div class="mock-top">
              <span class="mono">TU FORMA DE ARRANCAR</span>
              <span class="tag">DEMO</span>
            </div>
            <div class="tabs" role="group" aria-label="Formas de armar un presupuesto">
              <button
                type="button"
                data-action="method-tab"
                data-context="ai"
                :aria-pressed="method === 'ai'"
                aria-controls="method-ai"
                data-method="ai"
                @click="setMethod('ai')"
              >
                Con IA
              </button>
              <button
                type="button"
                data-action="method-tab"
                data-context="template"
                :aria-pressed="method === 'template'"
                aria-controls="method-template"
                data-method="template"
                @click="setMethod('template')"
              >
                Plantilla
              </button>
              <button
                type="button"
                data-action="method-tab"
                data-context="manual"
                :aria-pressed="method === 'manual'"
                aria-controls="method-manual"
                data-method="manual"
                @click="setMethod('manual')"
              >
                A mano
              </button>
            </div>
            <div id="method-ai" :hidden="method !== 'ai'">
              <div class="ai-prompt">
                <p id="prompt-text">{{ promptText }}</p>
                <button
                  id="voice"
                  class="voice-chip"
                  :class="{ playing: voicePlayed }"
                  type="button"
                  data-action="voice-example"
                  @click="playVoiceExample"
                >
                  <span class="wave" aria-hidden="true">
                    <i style="--h: 7px"> </i>
                    <i style="--h: 15px"> </i>
                    <i style="--h: 19px"> </i>
                    <i style="--h: 10px"> </i>
                    <i style="--h: 16px"> </i>
                  </span>
                  <span>Probar ejemplo de voz</span>
                </button>
              </div>
              <div class="catalog">
                <span class="mono">RECONOCIDOS EN TU CATÁLOGO</span>
                <div class="line">
                  <span> <span class="check">✓</span> Proyecto de interiores</span>
                  <b>$ 2.800.000</b>
                </div>
                <div class="line">
                  <span> <span class="check">✓</span> Relevamiento</span>
                  <b>$ 650.000</b>
                </div>
              </div>
              <div class="ai-question" aria-live="polite">
                <p id="ai-state">{{ aiState }}</p>
                <button
                  id="ai-action"
                  type="button"
                  class="small-button"
                  data-action="ai-next"
                  @click="advanceAi"
                >
                  {{ aiActionText }}
                </button>
                <div id="ai-diff" class="diff" :hidden="aiStep !== 2">
                  Notas: <ins>Incluye una ronda de ajustes.</ins>
                </div>
              </div>
              <p id="voice-note" class="mock-note">{{ voiceNote }}</p>
            </div>
            <div id="method-template" :hidden="method !== 'template'">
              <div class="template-card">
                <span class="tag">USADA 24 VECES</span>
                <h3>Proyecto<br />de interiores</h3>
                <p>5 servicios + 3 opcionales.<br />La base que ya conocés.</p>
                <button
                  id="use-template"
                  class="small-button"
                  type="button"
                  data-action="use-template"
                  @click="useTemplate"
                >
                  {{ templateButtonText }}
                </button>
                <p id="template-state" class="mock-note" aria-live="polite">{{ templateState }}</p>
              </div>
            </div>
            <div id="method-manual" :hidden="method !== 'manual'">
              <fieldset>
                <legend>Elegí los ítems del borrador.</legend>
                <label v-for="item in builderItems" :key="item.name" class="builder-row">
                  <input
                    v-model="item.on"
                    type="checkbox"
                    data-action="builder-item"
                    :data-context="item.name"
                    :aria-label="item.name + ', ' + formatMoney(item.price)"
                  />
                  <span>{{ item.name }}</span>
                  <b>{{ formatMoney(item.price) }}</b>
                </label>
              </fieldset>
              <p class="builder-result">
                Total:
                <output id="builder-total" aria-live="polite">{{
                  formatMoney(builderTotal)
                }}</output>
              </p>
              <p class="mock-note">Sin IA. Vos elegís cada servicio.</p>
            </div>
          </div>
        </article>
        <article class="beat" id="opcionales">
          <div class="beat-copy reveal">
            <div class="eyebrow">03 / Un extra, sin insistir</div>
            <h2>
              No empujes<br />el adicional.<br />
              <span class="accent">Dale su lugar.</span>
            </h2>
            <p>
              La visualización 3D no tiene por qué perderse entre dos mensajes. Mostrala como
              opcional: el cliente lo mira, lo marca si quiere y
              <strong>ve el total cambiar en vivo</strong>.
            </p>
            <p>
              Ves si llegó a la sección de opcionales y qué opciones seleccionó o desmarcó. Datos
              concretos para la próxima charla, sin adivinar qué le interesó.
            </p>
            <p v-if="isCopyV2" class="aside">Mostrá los extras con claridad. Tu cliente elige.</p>
            <p v-else class="aside">Una venta más, elegida por tu cliente. No peleada por vos.</p>
          </div>
          <div class="mock-stage reveal">
            <div class="mock-top">
              <span class="mono">DEL LADO DEL CLIENTE</span>
              <span>Opcional</span>
            </div>
            <div class="optional-teaser">
              <div class="optional-content">
                <h3>Visualización 3D</h3>
                <p>
                  Dos vistas del ambiente para revisar materiales y distribución. No está incluida
                  en la propuesta base.
                </p>
                <div class="line">
                  <label class="switch-label">
                    <input
                      id="teaser-choice"
                      v-model="teaserOn"
                      type="checkbox"
                      data-action="teaser-choice"
                      data-input="teaser-choice"
                    />Sumar al presupuesto</label
                  >
                  <b>+ $ 350.000</b>
                </div>
                <div class="total">
                  <span>Total</span>
                  <strong>
                    <output id="teaser-total" aria-live="polite">{{
                      formatMoney(teaserTotal)
                    }}</output>
                  </strong>
                </div>
              </div>
            </div>
            <div class="interest">
              <span class="mono">DEL LADO DE TU NEGOCIO · EJEMPLO</span>
              <strong id="interest-title" aria-live="polite">{{
                'Visualización 3D: ' + (teaserOn ? 'seleccionada' : 'no seleccionada')
              }}</strong>
              <p id="interest-state">
                {{
                  teaserOn
                    ? 'La opción elegida se suma al total.'
                    : 'El total incluye solo los servicios base.'
                }}
              </p>
            </div>
          </div>
        </article>
        <article class="beat" id="senales">
          <div class="beat-copy reveal">
            <div class="eyebrow">04 / El link no se queda callado</div>
            <h2 v-if="isCopyV2">Consultá la actividad.<br /><span class="accent">Decidí cómo seguir.</span></h2>
            <h2 v-else>De “¿lo habrá visto?”<br />a <span class="accent">“la llamo”.</span></h2>
            <p>
              Prio te avisa con la primera visualización. Consultás
              <strong>visitas registradas, tiempo en pantalla y opciones seleccionadas</strong>.
              También hasta dónde llegó en el presupuesto.
            </p>
            <p v-if="isCopyV2">
              Vos decidís cuándo retomar la conversación.
              <small
                >Cada visita corresponde a una sesión de navegador; reabrir el link en la misma
                sesión no suma otra visita.</small
              >
            </p>
            <p v-else>
              Cada visita corresponde a una sesión de navegador registrada. Volver a abrir el link
              en la misma sesión no suma otra visita. Vos decidís cuándo retomar la conversación.
            </p>
            <p v-if="isCopyV2" class="aside">La primera visita te avisa. El resto, a tu criterio.</p>
            <p v-else class="aside">Señales para hablar a tiempo. No para seguir adivinando.</p>
          </div>
          <div class="mock-stage signals-stage reveal">
            <div class="mock-top">
              <span class="mono">TU PRESUPUESTO / PAULA</span>
              <span class="tag">EJEMPLO</span>
            </div>
            <div class="signal-link">
              <span>prio.ar/u/sur-estudio/p/A7K2M</span>
              <button
                id="open-signal"
                class="signal-button"
                type="button"
                data-action="signal-open"
                aria-label="Simular una nueva visita al presupuesto"
                @click="simulateOpen"
              >
                ↗
              </button>
            </div>
            <div class="signal-chips">
              <div class="signal-chip">
                <strong id="visit-count">{{ visits + ' visitas' }}</strong>
                <span>sesiones registradas</span>
              </div>
              <div class="signal-chip">
                <strong>2 min 18 s</strong>
                <span>tiempo en pantalla</span>
              </div>
              <div class="signal-chip">
                <strong>90%</strong>
                <span>del presupuesto recorrido</span>
              </div>
              <div class="signal-chip">
                <strong>Seleccionada</strong>
                <span>Visualización 3D</span>
              </div>
            </div>
            <div class="signal-log" id="signal-log" aria-live="polite">
              <p><span class="check">✓</span>{{ signalLog }}</p>
              <p>Opciones marcadas: Visualización 3D.</p>
            </div>
            <div
              id="signal-toast"
              ref="toastRef"
              class="toast"
              role="status"
              aria-live="polite"
              aria-atomic="true"
            >
              <span class="toast-icon" aria-hidden="true">{{ toastIcon }}</span>
              <div>
                <strong>{{ toastTitle }}</strong>
                <small>{{ toastDetail }}</small>
              </div>
            </div>
            <button
              id="notify"
              type="button"
              class="small-button"
              data-action="signal-notify"
              @click="toggleNotify"
            >
              {{ approvedNotice ? 'Volver a las señales' : 'Ver aviso de aprobación' }}
            </button>
            <p class="mock-note">
              Actividad ilustrativa. No se rastrean tus visitas a esta página.
            </p>
          </div>
        </article>
        <article class="beat approval-beat" id="aprobacion">
          <div class="beat-copy reveal">
            <div class="eyebrow">05 / Ese pequeño gran sí</div>
            <h2>
              Lo elige.<br />Lo aprueba.<br />
              <span class="accent">Queda claro.</span>
            </h2>
            <p>
              Desde el mismo link, en el celular.
              <strong>Sin descargas. Sin crear una cuenta.</strong> Tu cliente confirma la
              aprobación, el presupuesto queda aprobado y recibís una notificación.
            </p>
            <p>
              Los opcionales elegidos se incorporan al total final. No tenés que reconstruir el
              acuerdo con una calculadora y veinte mensajes.
            </p>
          </div>
          <div class="link-flow reveal">
            <div class="flow-top">
              ↗ prio.ar/u/sur-estudio/p/A7K2M <span class="tag">SIN CUENTA</span>
            </div>
            <div class="flow-line"><span>01</span>Elige los opcionales.</div>
            <div class="flow-line"><span>02</span>Revisa servicios, notas y total.</div>
            <div class="flow-line"><span>✓</span>Confirma la aprobación. Te llega el aviso.</div>
            <a class="text-link" href="#probar"
              >Ahora hacelo vos <span aria-hidden="true">↓</span>
            </a>
          </div>
        </article>
        <section class="proof reveal" id="probar" aria-labelledby="proof-title">
          <div class="proof-heading">
            <div class="eyebrow">Menos promesas. Probalo.</div>
            <h2 id="proof-title">Ahora sos Paula.<br />Aprobá este presupuesto.</h2>
            <p>
              Sumá un extra. Sacá otro. Mirá el total.<br />Así de claro lo va a tener tu cliente.
            </p>
          </div>
          <div class="demo-shell">
            <div class="demo-paper">
              <div class="paper-head">
                <span class="studio">
                  <span class="studio-icon" aria-hidden="true">✳</span>sur estudio</span
                >
                <span id="demo-badge" class="tag">{{
                  receiptShown ? 'APROBADO · DEMO' : 'DEMO'
                }}</span>
              </div>
              <form
                id="approval-form"
                ref="approvalFormRef"
                :hidden="receiptShown"
                @submit.prevent="approvalDialogRef?.showModal()"
              >
                <h3>Presupuesto</h3>
                <p class="intro">
                  Para Paula García · Nº A7K2M<br />Presupuesto de ejemplo · Válido por 15 días
                </p>
                <div class="base-details">
                  <div class="line">
                    <span>Proyecto de interiores</span>
                    <b>$ 2.800.000</b>
                  </div>
                  <div class="line">
                    <span>Dirección de obra</span>
                    <b>$ 2.900.000</b>
                  </div>
                  <div class="line">
                    <span>Relevamiento</span>
                    <b>$ 650.000</b>
                  </div>
                  <div class="line">
                    <span>Planos técnicos</span>
                    <b>$ 450.000</b>
                  </div>
                  <div class="line">
                    <span>Cómputo de materiales</span>
                    <b>$ 250.000</b>
                  </div>
                  <div class="line base-total">
                    <span>Propuesta base</span>
                    <b>$ 7.050.000</b>
                  </div>
                </div>
                <fieldset>
                  <legend>¿Le sumamos algo más?</legend>
                  <label v-for="opt in approvalOptionals" :key="opt.name" class="option">
                    <input
                      v-model="opt.on"
                      name="optional"
                      type="checkbox"
                      :value="opt.price"
                      :data-name="opt.name"
                      data-action="approval-optional"
                      :data-context="opt.name"
                      :aria-label="opt.name + ', ' + formatMoney(opt.price)"
                    />
                    <span
                      >{{ opt.name }}<small>{{ opt.desc }}</small></span
                    >
                    <b>+ {{ formatMoney(opt.price) }}</b>
                  </label>
                </fieldset>
                <div class="total">
                  <span>Tu total <small>(ARS)</small> </span>
                  <strong>
                    <output
                      id="demo-total"
                      data-context="approval-total"
                      aria-live="polite"
                      aria-atomic="true"
                      >{{ formatMoney(demoTotal) }}</output
                    >
                  </strong>
                </div>
                <p class="terms-copy" id="terms-copy">
                  <strong>Notas:</strong> anticipo del 30% y saldo al entregar. Incluye los
                  servicios base y solo los opcionales elegidos. Aprobar no realiza ningún pago.
                </p>
                <button class="approve" type="submit" data-action="approval-submit">
                  Aprobar presupuesto <span aria-hidden="true">↗</span>
                </button>
              </form>
              <dialog
                ref="approvalDialogRef"
                class="approval-dialog"
                aria-labelledby="approval-confirm-title"
              >
                <h3 id="approval-confirm-title">¿Aprobar presupuesto?</h3>
                <p>Total: {{ formatMoney(demoTotal) }}. Esta demo no envía ni guarda nada.</p>
                <form method="dialog">
                  <button class="small-button" autofocus data-action="approval-cancel">
                    Cancelar
                  </button>
                  <button
                    class="approve"
                    type="button"
                    data-action="approval-confirm"
                    @click="submitApproval"
                  >
                    Confirmar aprobación
                  </button>
                </form>
              </dialog>
              <section
                id="receipt"
                data-context="approval-summary"
                class="receipt"
                aria-labelledby="receipt-title"
                :hidden="!receiptShown"
              >
                <div class="receipt-icon" aria-hidden="true">✓</div>
                <h3 id="receipt-title" ref="receiptTitleRef" tabindex="-1">
                  Presupuesto<br />aprobado.
                </h3>
                <p>
                  Resumen de esta demo.<br />En Prio, el presupuesto queda aprobado y recibís un
                  aviso.
                </p>
                <dl>
                  <div>
                    <dt>CLIENTE DEL PRESUPUESTO</dt>
                    <dd>Paula García · Cliente de ejemplo</dd>
                  </div>
                  <div>
                    <dt>HORA DE ESTA SIMULACIÓN</dt>
                    <dd id="receipt-date">{{ receiptDate }}</dd>
                  </div>
                  <div>
                    <dt>SERVICIOS BASE</dt>
                    <dd>
                      Proyecto de interiores, dirección de obra, relevamiento, planos técnicos y
                      cómputo de materiales.
                    </dd>
                  </div>
                  <div>
                    <dt>OPCIONALES INCORPORADOS</dt>
                    <dd id="receipt-options">{{ receiptOptions }}</dd>
                  </div>
                </dl>
                <div class="total">
                  <span>Total final <small>(ARS)</small> </span>
                  <strong id="receipt-total">{{ formatMoney(receiptTotal) }}</strong>
                </div>
                <p>Base + opcionales elegidos. Un solo total, sin cuentas pendientes de aclarar.</p>
                <button
                  id="reset"
                  class="small-button"
                  type="button"
                  data-action="approval-reset"
                  @click="resetApproval"
                >
                  Probar de nuevo ↺
                </button>
              </section>
            </div>
            <p class="demo-disclaimer">
              Demo ilustrativa. No se envía, no se guarda y no se cobra nada.
            </p>
          </div>
        </section>
      </section>
      <section class="trust wrap" aria-labelledby="trust-title">
        <div class="seal reveal" aria-hidden="true">
          <div>ACUERDO CLARO<b>✓</b>DE LOS DOS LADOS</div>
        </div>
        <div class="reveal">
          <div class="eyebrow">La tranquilidad también se presupuesta</div>
          <h2 id="trust-title">El “dale, hacelo”<br />deja de ser ambiguo.</h2>
          <p>
            Los servicios, las notas y los opcionales elegidos quedan en el presupuesto aprobado.
            Para que dentro de tres meses hablen del trabajo. No de “Yo pensé que incluía otra
            cosa”.
          </p>
          <div class="trust-points">
            <span>✓ Estado aprobado</span>
            <span>✓ Qué incluye</span>
            <span>✓ Total con opcionales</span>
          </div>
        </div>
      </section>
      <section class="closing" aria-labelledby="closing-title">
        <span class="closing-flower" aria-hidden="true">✳</span>
        <div class="wrap reveal">
          <div class="eyebrow">Tu trabajo merece esta presentación</div>
          <h2 id="closing-title">
            El próximo presupuesto que mandes puede llevar <span class="accent">tu marca.</span>
          </h2>
          <p>Menos texto para explicar.<br />Más claridad para que te digan que sí.</p>
          <a class="cta" :href="SIGNUP_URL">Probá gratis <span aria-hidden="true">↗</span> </a>
          <div class="guarantee">Sin tarjeta · Cancelás cuando quieras</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
import { useCopyVariant } from '@/composables/useCopyVariant';
import { SIGNUP_URL } from '@/constants';

const { isCopyV2 } = useCopyVariant();

useHead({
  title: 'Prio - Presupuestos con tu marca y aprobación online',
  meta: [
    {
      name: 'description',
      content:
        'Armá presupuestos con servicios claros y opcionales. Compartí un link con tu marca, recibí aprobaciones online y consultá su actividad.',
    },
    { name: 'theme-color', content: '#f7f3fb' },
  ],
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Urbanist:wght@500;600;700;800;900&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap',
    },
  ],
});

const moneyFormat = new Intl.NumberFormat('es-AR');

function formatMoney(value: number): string {
  return '$ ' + moneyFormat.format(value);
}

const rootRef = ref<HTMLElement | null>(null);
const reducedMotion = ref(false);
let mediaQuery: MediaQueryList | null = null;
let heroTimer = 0;

function isReduced(): boolean {
  return reducedMotion.value;
}

// Hero chat-wall to branded-link morph (illustrative demo).
const heroState = ref<'before' | 'after'>('before');

function setHero(state: 'before' | 'after'): void {
  window.clearTimeout(heroTimer);
  heroState.value = state;
  const stage = document.getElementById('hero-stage');
  stage?.querySelector('#hero-before')?.setAttribute('aria-hidden', String(state !== 'before'));
  stage?.querySelector('#hero-after')?.setAttribute('aria-hidden', String(state !== 'after'));
}

// Branded quote skins (6 illustrative designs).
const skinDots = [
  { label: 'Diseño 1, malva', swatch: '#9875ac' },
  { label: 'Diseño 2, oliva', swatch: '#858b69' },
  { label: 'Diseño 3, ciruela', swatch: '#563454' },
  { label: 'Diseño 4, arcilla', swatch: '#b17760' },
  { label: 'Diseño 5, azul', swatch: '#69889f' },
  { label: 'Diseño 6, tinta', swatch: '#302d35' },
];
const skinThemes = [
  { skin: '#795288', bg: '#fffafd', radius: '17px' },
  { skin: '#505c39', bg: '#fafbf1', radius: '3px' },
  { skin: '#f7e9ef', bg: '#51344f', radius: '20px' },
  { skin: '#864c37', bg: '#fff5eb', radius: '2px' },
  { skin: '#315b74', bg: '#f2f8fc', radius: '19px' },
  { skin: '#28262d', bg: '#ffffff', radius: '0px' },
];
const skinIndex = ref(0);
const skinVars = computed<string>(() => {
  const theme = skinThemes[skinIndex.value];
  return '--skin:' + theme.skin + ';--skin-bg:' + theme.bg + ';--skin-radius:' + theme.radius;
});

function selectSkin(index: number): void {
  skinIndex.value = index;
}

// Validity + expired preview.
const validity = ref('15');
const expired = ref(false);
const expiryNote = computed<string>(() =>
  expired.value
    ? 'Este presupuesto venció. Contactá a Sur Estudio en hola@sur-estudio.example para actualizarlo.'
    : 'Válido por ' + validity.value + ' días · Todo claro, desde el principio.',
);

function onValidityChange(): void {
  expired.value = false;
}

function toggleExpired(): void {
  expired.value = !expired.value;
}

// Build methods: IA / plantilla / manual.
const method = ref<'ai' | 'template' | 'manual'>('ai');

function setMethod(next: 'ai' | 'template' | 'manual'): void {
  method.value = next;
}

// Voice example (does not use your microphone).
const promptText = ref(
  '“Presupuesto para Sofía: proyecto de interiores y relevamiento del departamento.”',
);
const voiceNote = ref('Ejemplo guiado. Sin IA ni micrófono activos.');
const voicePlayed = ref(false);

function playVoiceExample(): void {
  promptText.value =
    '“Presupuesto para Sofía: proyecto de interiores y relevamiento del departamento.”';
  voiceNote.value = 'Voz → texto → tu catálogo. Transcripción de ejemplo; no se usa tu micrófono.';
  voicePlayed.value = false;
  if (!isReduced()) {
    requestAnimationFrame(() => {
      voicePlayed.value = true;
    });
  }
}

// IA 4-step guided cycle.
const aiStates = [
  '¿Qué alcance querés dejar en las notas?',
  'Borrador para Sofía · Notas: cocina y living. Total $ 3.450.000. Importes de ejemplo.',
  'Revisá el cambio antes de aplicarlo. Servicios y precios: sin cambios.',
  'Nota agregada: incluye una ronda de ajustes. Total $ 3.450.000. Listo para tu revisión final.',
];
const aiActions = [
  'Cocina y living',
  'Agregar nota: “Incluye una ronda de ajustes”',
  'Aplicar cambio',
  'Volver al ejemplo',
];
const aiStep = ref(0);
const aiState = computed<string>(() => aiStates[aiStep.value]);
const aiActionText = computed<string>(() => aiActions[aiStep.value]);

function advanceAi(): void {
  aiStep.value = (aiStep.value + 1) % 4;
}

// Template shortcut.
const templateState = ref('Guardada para no volver a escribir lo mismo.');
const templateButtonText = ref('Usar esta base ↗');

function useTemplate(): void {
  templateState.value =
    'Base cargada: 5 servicios + 3 opcionales. Ahora revisás cliente, notas y precios.';
  templateButtonText.value = '✓ Base lista para revisar';
}

// Manual builder totals.
interface BuilderItem {
  name: string;
  price: number;
  on: boolean;
}

const builderItems = ref<BuilderItem[]>([
  { name: 'Proyecto de interiores', price: 2800000, on: true },
  { name: 'Relevamiento', price: 650000, on: true },
  { name: 'Planos técnicos', price: 450000, on: false },
]);
const builderTotal = computed<number>(() =>
  builderItems.value.reduce((sum, item) => sum + (item.on ? item.price : 0), 0),
);

// Optional teaser: live total + visible interest.
const teaserOn = ref(false);
const teaserTotal = computed<number>(() => 7050000 + (teaserOn.value ? 350000 : 0));

// Signals demo.
const visits = ref(4);
const signalLog = ref('4 sesiones de navegador registradas.');
const toastTitle = ref('Primera visualización del presupuesto');
const toastDetail = ref('Ejemplo del aviso que recibís cuando se ve por primera vez.');
const toastIcon = ref('↗');
const approvedNotice = ref(false);
const toastRef = ref<HTMLElement | null>(null);

function animateToast(): void {
  if (!isReduced() && toastRef.value && typeof toastRef.value.animate === 'function') {
    toastRef.value.animate(
      [
        { opacity: 0.5, transform: 'translateY(7px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' },
    );
  }
}

function simulateOpen(): void {
  visits.value += 1;
  signalLog.value = visits.value + ' sesiones registradas. Nueva visita simulada.';
  toastTitle.value = 'Actividad del presupuesto';
  toastDetail.value =
    'La nueva visita actualiza las métricas, no genera otro aviso de primera visualización.';
  toastIcon.value = '↗';
  approvedNotice.value = false;
  animateToast();
}

function toggleNotify(): void {
  approvedNotice.value = !approvedNotice.value;
  if (approvedNotice.value) {
    toastTitle.value = 'Paula aprobó tu presupuesto';
    toastDetail.value = 'Ejemplo · Con Visualización 3D incluida';
    toastIcon.value = '✓';
  } else {
    toastTitle.value = 'Primera visualización del presupuesto';
    toastDetail.value = 'Ejemplo del aviso que recibís cuando se ve por primera vez.';
    toastIcon.value = '↗';
  }
  animateToast();
}

// Approval demo: optionals -> live total -> approve -> receipt + reset.
const BASE_TOTAL = 7050000;

interface ApprovalOptional {
  name: string;
  desc: string;
  price: number;
  on: boolean;
}

const approvalOptionals = ref<ApprovalOptional[]>([
  { name: 'Visualización 3D', desc: 'Dos vistas del ambiente.', price: 350000, on: false },
  { name: 'Visita adicional', desc: 'Revisión presencial de la obra.', price: 480000, on: false },
  {
    name: 'Manual de mantenimiento',
    desc: 'Cuidados de materiales y terminaciones.',
    price: 220000,
    on: false,
  },
]);
const demoTotal = computed<number>(
  () =>
    BASE_TOTAL + approvalOptionals.value.reduce((sum, opt) => sum + (opt.on ? opt.price : 0), 0),
);
const approvalDialogRef = ref<HTMLDialogElement | null>(null);
const receiptShown = ref(false);
const receiptDate = ref('');
const receiptOptions = ref('');
const receiptTotal = ref(0);
const approvalFormRef = ref<HTMLFormElement | null>(null);
const receiptTitleRef = ref<HTMLElement | null>(null);

function selectedOptionals(): ApprovalOptional[] {
  return approvalOptionals.value.filter((opt) => opt.on);
}

async function submitApproval(): Promise<void> {
  approvalDialogRef.value?.close();
  const chosen = selectedOptionals();
  receiptDate.value =
    new Intl.DateTimeFormat('es-AR', {
      dateStyle: 'long',
      timeStyle: 'short',
      timeZone: 'America/Argentina/Buenos_Aires',
    }).format(new Date()) + ' · Hora de Argentina';
  receiptOptions.value = chosen.length
    ? chosen.map((opt) => opt.name + ' (' + formatMoney(opt.price) + ')').join(' · ')
    : 'Ninguno. Se aprobó solo la propuesta base.';
  receiptTotal.value = demoTotal.value;
  receiptShown.value = true;
  await nextTick();
  receiptTitleRef.value?.focus({ preventScroll: true });
  document
    .getElementById('receipt')
    ?.scrollIntoView({ block: 'nearest', behavior: isReduced() ? 'auto' : 'smooth' });
}

async function resetApproval(): Promise<void> {
  approvalOptionals.value.forEach((opt) => {
    opt.on = false;
  });
  receiptShown.value = false;
  await nextTick();
  approvalFormRef.value?.querySelector('input')?.focus({ preventScroll: true });
  approvalFormRef.value?.scrollIntoView({
    block: 'start',
    behavior: isReduced() ? 'auto' : 'smooth',
  });
}

// Pain count-ups (client-only, honors reduced motion).
let countObserver: IntersectionObserver | null = null;
let disposed = false;
const countRafIds = new Set<number>();

function animateCount(el: HTMLElement, end: number): void {
  const start = performance.now();
  const tick = (now: number): void => {
    if (disposed) return;
    const progress = Math.min(1, (now - start) / 800);
    el.textContent = String(Math.round(end * (1 - Math.pow(1 - progress, 3))));
    if (progress >= 1 || isReduced()) {
      el.textContent = String(end);
      return;
    }
    countRafIds.add(requestAnimationFrame(tick));
  };
  countRafIds.add(requestAnimationFrame(tick));
}

function onMotionChange(): void {
  reducedMotion.value = mediaQuery?.matches ?? false;
  if (reducedMotion.value) {
    setHero('after');
  }
}

onMounted(() => {
  mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  reducedMotion.value = mediaQuery.matches;
  mediaQuery.addEventListener('change', onMotionChange);
  if (reducedMotion.value) {
    setHero('after');
  } else {
    heroTimer = window.setTimeout(() => setHero('after'), 2600);
  }
  if (!('IntersectionObserver' in window)) return;
  countObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('[data-count]').forEach((node) => {
          if (!(node instanceof HTMLElement) || isReduced()) return;
          animateCount(node, Number(node.dataset.count));
        });
        countObserver?.unobserve(entry.target);
      });
    },
    { threshold: 0.08 },
  );
  rootRef.value?.querySelectorAll('.reveal').forEach((el) => countObserver?.observe(el));
});

onUnmounted(() => {
  disposed = true;
  window.clearTimeout(heroTimer);
  countObserver?.disconnect();
  mediaQuery?.removeEventListener('change', onMotionChange);
  countRafIds.forEach((id) => cancelAnimationFrame(id));
  countRafIds.clear();
});

useScrollReveal();
</script>

<style scoped>
/* Prototype deltas: local shadow token, tighter body leading. */
.l3 {
  --shadow: 0 22px 60px #3120470e;
  line-height: 1.7;
}
h1,
h2,
h3,
h4 {
  font-family: Urbanist, Arial, sans-serif;
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.04;
}
h1 {
  font-size: clamp(49px, 12.8vw, 76px);
}
h2 {
  font-size: clamp(39px, 9.9vw, 60px);
}
h3 {
  font-size: 30px;
}

a {
  color: inherit;
  text-decoration: none;
}
button,
input,
select {
  font: inherit;
  color: inherit;
}
button,
select {
  cursor: pointer;
}
button {
  border: 0;
}
button,
a,
input,
select {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
button,
a,
select {
  min-height: 44px;
}
button {
  transition: transform 0.18s var(--ease);
}
button:active,
.cta:active {
  transform: scale(0.98);
}

[hidden] {
  display: none !important;
}
button:disabled {
  cursor: default;
  opacity: 0.55;
}
input[type='checkbox'] {
  accent-color: var(--violet);
  width: 21px;
  height: 21px;
  flex: none;
}
select {
  max-width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fffafd;
  padding: 8px 10px;
}
fieldset {
  padding: 0;
  margin: 0;
  border: 0;
  min-width: 0;
}
legend {
  margin-bottom: 12px;
  font-weight: 600;
}
.wrap {
  width: min(1140px, calc(100% - 40px));
  margin-inline: auto;
}
.mono,
.eyebrow {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
}
.eyebrow {
  text-transform: uppercase;
  color: var(--violet);
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}
.eyebrow:before {
  content: '';
  width: 6px;
  height: 6px;
  background: var(--pink);
  border-radius: 50%;
  flex: none;
}
.cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 16px 23px;
  min-height: 56px;
  border-radius: 16px;
  border: 1px solid #bea0d1;
  background: var(--aurora);
  font-size: 14px;
  font-weight: 700;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.2s var(--ease);
}
.cta:before {
  content: '';
  position: absolute;
  inset: -100%;
  background: linear-gradient(100deg, transparent 43%, #ffffff80 50%, transparent 57%);
  transform: translateX(-65%) rotate(-10deg);
  z-index: -1;
}
.cta:hover:before,
.cta:focus-visible:before {
  animation: sheen 0.8s var(--ease);
}
@keyframes sheen {
  to {
    transform: translateX(65%) rotate(-10deg);
  }
}
.guarantee {
  font-size: 11px;
  margin-top: 11px;
  color: var(--muted);
}
.text-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #bba7d1;
  font-size: 12px;
  font-weight: 600;
}

.hero {
  padding: 38px 0 54px;
  display: grid;
  gap: 36px;
}
.hero-copy > p {
  font-size: 15px;
  max-width: 470px;
  margin: 24px 0;
}
.hero-copy > p strong {
  color: var(--ink);
  font-weight: 500;
}
.hero-copy .guarantee {
  margin-top: 12px;
}
.hero-visual {
  position: relative;
  min-width: 0;
}
.hero-stage {
  height: 398px;
  position: relative;
  isolation: isolate;
  display: grid;
  align-items: center;
  padding: 24px 15px;
}
.hero-stage:before {
  content: '';
  position: absolute;
  inset: 20px 0 15px;
  background:
    radial-gradient(ellipse at 20% 30%, #d9cbffb0, transparent 65%),
    radial-gradient(ellipse at 80% 80%, #ffc0d7a0, transparent 65%);
  border-radius: 48% 48% 36% 40%;
  z-index: -2;
}
.orbit {
  position: absolute;
  inset: 42px 0 10px;
  border: 1px solid #c7b4d7;
  border-radius: 50%;
  transform: rotate(-16deg);
  z-index: -1;
}
.spark {
  position: absolute;
  right: 4px;
  top: 0;
  font-size: 54px;
  line-height: 1;
  color: var(--violet);
  transform: rotate(12deg);
}
.hero-layer {
  grid-area: 1/1;
  transition:
    opacity 0.65s var(--ease),
    transform 0.75s var(--ease);
  min-width: 0;
}
.chat-sheet {
  padding: 22px 22px 18px;
  border: 1px solid #cbd8c5;
  border-radius: 20px 20px 5px 20px;
  background: #eaf1e5;
  box-shadow: var(--shadow);
  transform: rotate(-4deg);
}
.chat-header {
  display: flex;
  gap: 9px;
  align-items: center;
  font-size: 11px;
  margin-bottom: 13px;
  color: #5f7255;
}
.avatar {
  height: 28px;
  width: 28px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #d7e1cf;
  font-weight: 700;
}
.chat-sheet p {
  font-size: 13px;
  line-height: 1.8;
  color: #52604a;
}
.chat-sheet small {
  display: block;
  text-align: right;
  color: #6b7963;
  margin-top: 10px;
  font-size: 10px;
}
.chat-reply {
  position: absolute;
  bottom: -28px;
  right: 0;
  padding: 10px 16px;
  background: #fffcff;
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: var(--shadow);
  font-size: 12px;
  transform: rotate(5deg);
}
.hero-paper {
  opacity: 0;
  transform: translateY(30px) rotate(7deg) scale(0.9);
  pointer-events: none;
}
.hero-stage[data-state='after'] .hero-paper {
  opacity: 1;
  transform: translateY(0) rotate(-2deg) scale(1);
}
.hero-stage[data-state='after'] .chat-sheet {
  opacity: 0;
  transform: translateY(-24px) rotate(-9deg) scale(0.93);
  pointer-events: none;
}
.paper {
  background: #fffcff;
  border: 1px solid #e0d5e9;
  border-radius: 21px;
  padding: 23px;
  box-shadow: var(--shadow);
  position: relative;
}
.paper-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
}
.studio {
  display: flex;
  align-items: center;
  gap: 9px;
  font:
    800 22px/1 Urbanist,
    sans-serif;
  letter-spacing: -0.8px;
}
.studio-icon {
  font-size: 29px;
  color: #83599b;
}
.tag {
  font:
    500 9px/1.5 'IBM Plex Mono',
    monospace;
  letter-spacing: 0.02em;
  padding: 5px 8px;
  border-radius: 6px;
  background: #eee7f5;
  color: #654e79;
  white-space: nowrap;
}
.paper h3 {
  font-size: 31px;
  margin: 22px 0 8px;
}
.paper .small {
  font-size: 11px;
}
.line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid var(--line);
  padding: 12px 0;
  font-size: 12px;
}
.line b {
  white-space: nowrap;
  font-weight: 600;
}
.total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 18px;
  font-size: 12px;
}
.total strong {
  font:
    800 29px/1.1 Urbanist,
    sans-serif;
  letter-spacing: -1px;
  font-variant-numeric: tabular-nums;
}
.hero-paper .link-bar {
  margin-top: 15px;
  color: var(--violet);
}
.link-bar {
  font:
    11px/1.7 'IBM Plex Mono',
    monospace;
  overflow-wrap: anywhere;
}
.floating-label {
  position: absolute;
  bottom: -17px;
  right: -7px;
  background: var(--lime);
  border: 1px solid #c0d97d;
  border-radius: 12px;
  padding: 9px 14px;
  font-size: 11px;
  transform: rotate(3deg);
}
.compare-control {
  display: flex;
  justify-content: center;
  gap: 5px;
  position: relative;
  margin: 14px auto 0;
  width: max-content;
  background: #ede6f2;
  border: 1px solid var(--line);
  padding: 4px;
  border-radius: 99px;
}
.compare-control button {
  background: transparent;
  border-radius: 99px;
  padding: 8px 18px;
  font-size: 12px;
}
.compare-control button[aria-pressed='true'] {
  background: #fffcff;
  box-shadow: 0 3px 8px #231b360b;
}
.caption {
  margin-top: 12px;
  text-align: center;
  font-size: 10px;
  color: var(--muted);
}
.bridge {
  border-block: 1px solid var(--line);
  padding: 18px 0;
}
.bridge .wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.bridge p {
  font-size: 12px;
}
.bridge .mono {
  color: var(--violet);
  flex: none;
}
.section {
  padding-block: 70px;
}
.pain-heading {
  max-width: 730px;
}
.pain-grid {
  display: grid;
  gap: 0;
  margin-top: 34px;
}
.pain-card {
  padding: 25px 0;
  border-top: 1px solid var(--line);
}
.pain-stat {
  font:
    800 74px/1 Urbanist,
    sans-serif;
  letter-spacing: -4px;
  margin-bottom: 16px;
}
.pain-stat small {
  font-size: 23px;
  letter-spacing: -0.6px;
  color: var(--muted);
}
.pain-card h3 {
  font-size: 23px;
  margin-bottom: 12px;
}
.pain-card p {
  font-size: 13px;
  max-width: 310px;
}
.pain-end {
  border-top: 1px solid var(--line);
  padding-top: 25px;
  font-size: 15px;
  color: var(--ink);
  max-width: 720px;
}
.pain-end span {
  color: var(--muted);
}
.value {
  border-top: 1px solid var(--line);
}
.value-head {
  padding-top: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.value-head p {
  font-size: 11px;
  text-align: right;
}
.value-head .eyebrow {
  margin: 0;
}
.beat {
  display: grid;
  gap: 32px;
  padding-block: 58px;
  border-bottom: 1px solid var(--line);
  align-items: center;
}
.beat-copy {
  max-width: 450px;
}
.beat .eyebrow {
  margin-bottom: 19px;
}
.beat-copy > p {
  margin-top: 22px;
  font-size: 14px;
  line-height: 1.85;
}
.beat-copy > p strong {
  font-weight: 500;
  color: var(--ink);
}
.beat-copy .aside {
  font-size: 12px;
  padding-left: 15px;
  border-left: 2px solid #c3acd8;
  margin-top: 24px;
}
.mock-stage {
  min-width: 0;
  border: 1px solid #e4d9ed;
  border-radius: 28px;
  background: linear-gradient(145deg, #eee5f5, #f8eff3);
  padding: 20px;
}
.mock-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 17px;
  font-size: 10px;
  color: var(--muted);
}
.skin-quote {
  --skin: #795288;
  --skin-bg: #fffafd;
  --skin-radius: 17px;
  border-radius: var(--skin-radius);
  background: var(--skin-bg);
  color: var(--skin);
  padding: 20px;
  border: 1px solid #fff;
  box-shadow: var(--shadow);
}
.skin-quote .studio-icon {
  color: inherit;
}
.skin-quote .small {
  color: inherit;
}
.skin-quote h3 {
  margin: 25px 0 18px;
  font-size: 34px;
}
.skin-quote .line {
  border-color: color-mix(in srgb, var(--skin) 18%, transparent);
  font-size: 11px;
}
.skin-quote .paper-head {
  border-color: color-mix(in srgb, var(--skin) 18%, transparent);
}
.skin-quote[data-skin='1'] h3 {
  font-family: Georgia, serif;
  font-weight: 400;
  font-style: italic;
}
.skin-quote[data-skin='2'] h3 {
  text-transform: uppercase;
  font-size: 30px;
  letter-spacing: -1px;
}
.skin-quote[data-skin='3'] h3 {
  font-family: Georgia, serif;
  font-weight: 400;
}
.skin-quote[data-skin='4'] .paper-head {
  flex-direction: column;
  align-items: flex-start;
}
.skin-quote[data-skin='5'] h3 {
  letter-spacing: -2px;
  font-weight: 900;
}
.skin-toolbar {
  margin-top: 15px;
}
.skin-dots {
  display: flex;
  justify-content: center;
  gap: 2px;
}
.skin-dots button {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border-radius: 50%;
}
.skin-dots i {
  display: block;
  width: 23px;
  height: 23px;
  background: var(--swatch);
  border-radius: 50%;
  border: 2px solid #ffffff;
}
.skin-dots button[aria-pressed='true'] i {
  outline: 2px solid var(--ink);
  outline-offset: 3px;
}
.validity {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 9px;
  font-size: 11px;
}
.small-button {
  padding: 9px 12px;
  border: 1px solid #cdbddb;
  background: #fffafd;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}
.expiry {
  margin-top: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 10px;
}
.expiry p {
  font-size: 10px;
}
.expiry-note {
  font-size: 11px;
  margin-top: 14px;
  color: inherit;
}
.tabs {
  display: flex;
  gap: 3px;
  padding: 4px;
  background: #e6dced;
  border-radius: 13px;
  margin-bottom: 20px;
}
.tabs button {
  flex: 1;
  border-radius: 9px;
  background: transparent;
  font-size: 12px;
  padding: 9px 6px;
}
.tabs button[aria-pressed='true'] {
  background: #fffcff;
  box-shadow: 0 3px 9px #231b3610;
}
.ai-prompt {
  border: 1px solid #d8c3e6;
  border-radius: 15px;
  padding: 15px;
  background: #fffafd;
}
.ai-prompt p {
  color: var(--ink);
  font-size: 13px;
  line-height: 1.7;
}
.voice-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #efe4fa;
  border-radius: 99px;
  font-size: 11px;
  padding: 8px 12px;
  margin-top: 12px;
  min-height: 44px;
}
.wave {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 19px;
}
.wave i {
  display: block;
  width: 3px;
  height: var(--h);
  background: var(--violet);
  border-radius: 2px;
}
.voice-chip.playing .wave i {
  animation: wave 0.55s ease-in-out 2 alternate;
}
@keyframes wave {
  to {
    transform: scaleY(0.35);
  }
}
.catalog {
  margin: 18px 0;
}
.catalog .mono {
  font-size: 9px;
  color: var(--violet);
}
.catalog .line {
  font-size: 11px;
}
.check {
  color: #497147;
  font-weight: 700;
}
.ai-question {
  border-radius: 12px;
  background: #fdf9ff;
  padding: 14px;
  font-size: 12px;
  min-height: 106px;
}
.ai-question p {
  color: var(--ink);
}
.ai-question .small-button {
  margin-top: 10px;
  background: #e6dbf8;
}
.diff {
  padding: 12px 0;
  font-size: 12px;
}
.diff del {
  color: #9b3e55;
  background: #f9e8ed;
  padding: 3px;
}
.diff ins {
  color: #38663d;
  background: #eaf4dd;
  padding: 3px;
  text-decoration: none;
}
.mock-note {
  font-size: 10px;
  color: var(--muted);
  margin-top: 13px;
}
.template-card {
  background: #fffcff;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 22px;
}
.template-card h3 {
  font-size: 28px;
  margin: 20px 0 9px;
}
.template-card p {
  font-size: 12px;
}
.template-card .small-button {
  width: 100%;
  margin-top: 24px;
}
.builder-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
  font-size: 12px;
  cursor: pointer;
  min-height: 54px;
}
.builder-row b {
  margin-left: auto;
  white-space: nowrap;
  font-size: 11px;
}
.builder-result {
  font-weight: 600;
  margin-top: 18px;
  font-size: 13px;
}
.optional-teaser {
  background: #fffcff;
  border-radius: 20px;
  border: 1px solid var(--line);
  overflow: hidden;
}
.optional-content {
  padding: 20px;
}
.optional-content h3 {
  font-size: 26px;
}
.optional-content p {
  font-size: 12px;
  margin-top: 7px;
}
.optional-content .line {
  border: 0;
  padding-bottom: 0;
}
.switch-label {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 12px;
  cursor: pointer;
  min-height: 48px;
}
.switch-label input {
  margin: 0;
}
.interest {
  margin-top: 16px;
  padding: 14px;
  border: 1px dashed #c4acd8;
  border-radius: 13px;
  font-size: 11px;
}
.interest strong {
  display: block;
  font-size: 12px;
  color: var(--ink);
  margin: 5px 0;
}
.interest p {
  font-size: 11px;
}
.signals-stage {
  background: linear-gradient(145deg, #e9e0f2, #eee9f6);
}
.signal-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fffcff;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 10px 13px;
}
.signal-link span {
  font:
    11px 'IBM Plex Mono',
    monospace;
}
.signal-button {
  background: #ede2f9;
  border-radius: 8px;
  width: 44px;
  font-size: 22px;
}
.signal-chips {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
  margin-top: 17px;
}
.signal-chip {
  border: 1px solid #dfd3e9;
  background: #ffffff80;
  border-radius: 13px;
  padding: 14px;
}
.signal-chip strong {
  display: block;
  font:
    800 26px Urbanist,
    sans-serif;
  letter-spacing: -1px;
}
.signal-chip span {
  font-size: 10px;
  color: var(--muted);
}
.signal-log {
  padding: 18px 2px;
  font-size: 11px;
}
.signal-log p {
  font-size: 11px;
  margin: 5px 0;
}
.signal-log .check {
  margin-right: 8px;
}
.toast {
  background: linear-gradient(125deg, #42325c, #211b34 65%, #3c273e);
  color: #fff5ff;
  border: 1px solid #745884;
  border-radius: 16px;
  padding: 18px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 12px 26px #34234320;
}
.toast:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 72%;
  height: 3px;
  background: var(--aurora);
}
.toast-icon {
  display: grid;
  place-items: center;
  flex: none;
  width: 30px;
  height: 30px;
  background: var(--lime);
  color: #314121;
  border-radius: 10px;
}
.toast strong {
  font-size: 12px;
  line-height: 1.6;
  display: block;
}
.toast small {
  display: block;
  font-size: 10px;
  color: #d3c2df;
  margin-top: 3px;
}
.signals-stage > .small-button {
  width: 100%;
  margin-top: 14px;
}
.approval-beat {
  border: 0;
  padding-bottom: 30px;
}
.link-flow {
  padding: 24px;
  background: #efe8f6;
  border: 1px solid #e0d4ea;
  border-radius: 24px;
  display: grid;
  gap: 17px;
}
.flow-top {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px;
  color: var(--violet);
}
.flow-top .tag {
  margin-left: auto;
}
.flow-line {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
}
.flow-line span {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fffcff;
  border: 1px solid var(--line);
  font:
    12px 'IBM Plex Mono',
    monospace;
  flex: none;
}
.flow-line:last-child span {
  background: var(--lime);
  border-color: #c8da9b;
}
.link-flow .text-link {
  width: max-content;
  margin-left: 46px;
}
.proof {
  margin-top: 30px;
  padding: 45px 20px 25px;
  background: linear-gradient(145deg, #ede1f5, #f5e9f0 65%, #f4ede4);
  border: 1px solid #dfd0e8;
  border-radius: 30px;
  position: relative;
}
.proof-heading {
  max-width: 580px;
  margin: 0 auto 30px;
  text-align: center;
}
.proof-heading .eyebrow {
  justify-content: center;
}
.proof-heading h2 {
  font-size: 36px;
}
.proof-heading p {
  font-size: 13px;
  margin-top: 16px;
}
.demo-shell {
  max-width: 620px;
  margin: auto;
}
.demo-paper {
  background: #fffcff;
  border: 1px solid #fff;
  border-radius: 21px;
  padding: 20px;
  box-shadow: 0 24px 64px #54326012;
}
.demo-paper .studio {
  font-size: 23px;
}
.demo-paper h3 {
  font-size: 36px;
  margin: 24px 0 8px;
}
.demo-paper .intro {
  font-size: 12px;
  margin-bottom: 20px;
}
.base-details {
  border-block: 1px solid var(--line);
  padding: 4px 0;
  margin-bottom: 20px;
}
.base-details .line {
  border: 0;
  font-size: 11px;
  padding: 8px 0;
}
.base-details .base-total {
  border-top: 1px solid var(--line);
  font-size: 12px;
  margin-top: 5px;
  padding-block: 13px;
}
.option {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 15px 10px;
  border: 1px solid var(--line);
  border-radius: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  min-height: 65px;
  background: #fffafd;
}
.option:has(input:checked) {
  background: #f0e8fb;
  border-color: #b59ace;
}
.option input {
  margin: 0;
}
.option span {
  flex: 1;
  line-height: 1.5;
  font-size: 12px;
}
.option small {
  display: block;
  font-size: 10px;
  color: var(--muted);
  margin-top: 2px;
}
.option b {
  font-size: 11px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.demo-paper .total {
  padding: 16px 0 22px;
}
.demo-paper .total strong {
  font-size: 34px;
}
.terms-copy {
  padding: 13px;
  background: #f5f0f8;
  border-radius: 10px;
  font-size: 11px;
  color: var(--muted);
  margin-bottom: 15px;
}
.approve {
  width: 100%;
  background: var(--ink);
  color: #fff6ff;
  border: 1px solid #614775;
  border-radius: 13px;
  padding: 14px 18px;
  font-weight: 600;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.demo-disclaimer {
  text-align: center;
  font-size: 10px;
  margin-top: 17px;
  color: #776581;
}
.receipt {
  padding: 12px 0 0;
}
.receipt-icon {
  display: grid;
  place-items: center;
  width: 57px;
  height: 57px;
  margin: 6px 0 20px;
  border-radius: 18px;
  background: var(--lime);
  font-size: 27px;
  color: #345525;
}
.receipt h3 {
  margin-top: 0;
}
.receipt > p {
  font-size: 12px;
  margin-top: 9px;
}
.receipt dl {
  margin: 23px 0;
  font-size: 12px;
}
.receipt dl > div {
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
}
.receipt dt {
  color: var(--muted);
  font-size: 10px;
  margin-bottom: 5px;
}
.receipt dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.receipt .total {
  border-top: 2px solid var(--ink);
  margin-top: 22px;
}
.receipt button {
  width: 100%;
  margin-top: 15px;
}
.trust {
  padding-block: 75px;
  display: grid;
  gap: 28px;
}
.seal {
  width: 106px;
  height: 106px;
  border: 1px solid #baa6ce;
  border-radius: 50%;
  display: grid;
  place-items: center;
  text-align: center;
  position: relative;
  transform: rotate(-10deg);
  color: var(--violet);
  font:
    10px/1.65 'IBM Plex Mono',
    monospace;
  letter-spacing: 0.04em;
}
.seal:before {
  content: '';
  position: absolute;
  inset: 6px;
  border: 1px dashed #c3aed6;
  border-radius: 50%;
}
.seal b {
  font:
    30px Urbanist,
    sans-serif;
  display: block;
}
.trust h2 {
  max-width: 700px;
}
.trust p {
  font-size: 14px;
  margin-top: 22px;
  max-width: 630px;
}
.trust-points {
  display: flex;
  flex-wrap: wrap;
  gap: 9px 22px;
  margin-top: 23px;
  font-size: 11px;
  color: var(--violet);
}
.closing {
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 70px 0 80px;
  border-top: 1px solid #dacbe6;
  background:
    radial-gradient(ellipse at 15% 100%, #d9cbff90, transparent 65%),
    radial-gradient(ellipse at 85% 100%, #ffc0d790, transparent 65%);
}
.closing .eyebrow {
  justify-content: center;
}
.closing h2 {
  max-width: 760px;
  margin: auto;
}
.closing p {
  font-size: 14px;
  margin: 24px auto;
  max-width: 470px;
}
.closing .cta {
  min-width: 215px;
}
.closing-flower {
  display: block;
  font-size: 50px;
  color: var(--violet);
  line-height: 1;
  margin-bottom: 30px;
}
.motion .reveal {
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 0.65s var(--ease),
    transform 0.65s var(--ease);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
@media (min-width: 760px) {
  .wrap {
    width: min(1140px, calc(100% - 80px));
  }
  .hero {
    grid-template-columns: 1.05fr 1fr;
    gap: 50px;
    align-items: center;
    padding: 65px 0 80px;
  }
  .hero h1 {
    font-size: clamp(58px, 6.1vw, 82px);
  }
  .hero-copy > p {
    font-size: 15px;
  }
  .hero-stage {
    height: 460px;
    padding: 30px;
  }
  .hero-paper .paper {
    padding: 28px;
  }
  .hero-paper .paper h3 {
    font-size: 38px;
  }
  .chat-sheet p {
    font-size: 14px;
  }
  .chat-sheet {
    padding: 26px;
  }
  .spark {
    font-size: 72px;
  }
  .floating-label {
    right: -20px;
    font-size: 12px;
  }
  .hero-stage:before {
    inset: 20px -20px;
  }
  .bridge {
    padding: 20px 0;
  }
  .bridge p {
    font-size: 13px;
  }
  .section {
    padding-block: 90px;
  }
  .pain-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
    margin-top: 42px;
  }
  .pain-card {
    padding: 28px 0 35px;
  }
  .pain-stat {
    font-size: 85px;
  }
  .pain-end {
    max-width: none;
  }
  .beat {
    grid-template-columns: 1fr 1fr;
    gap: 8%;
    padding-block: 75px;
  }
  .beat:nth-of-type(even) .beat-copy {
    grid-column: 2;
    grid-row: 1;
  }
  .beat:nth-of-type(even) .mock-stage {
    grid-column: 1;
    grid-row: 1;
  }
  .beat h2 {
    font-size: 52px;
  }
  .mock-stage {
    padding: 28px;
  }
  .skin-quote {
    padding: 25px;
  }
  .skin-quote h3 {
    font-size: 42px;
  }
  .skin-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
  }
  .skin-dots {
    gap: 0;
  }
  .skin-dots button {
    width: 44px;
  }
  .validity {
    margin-top: 0;
    display: block;
  }
  .validity label {
    display: block;
    font-size: 9px;
    margin-bottom: 5px;
  }
  .validity select {
    font-size: 11px;
  }
  .approval-beat {
    padding-bottom: 40px;
  }
  .proof {
    padding: 55px 60px 30px;
    margin-top: 0;
  }
  .proof-heading h2 {
    font-size: 47px;
  }
  .demo-paper {
    padding: 32px 38px;
  }
  .demo-paper h3 {
    font-size: 42px;
  }
  .option {
    padding: 14px 17px;
  }
  .option span {
    font-size: 13px;
  }
  .option b {
    font-size: 12px;
  }
  .proof-heading {
    margin-bottom: 35px;
  }
  .trust {
    grid-template-columns: 145px 1fr;
    align-items: center;
    gap: 45px;
    padding-block: 100px;
  }
  .seal {
    width: 130px;
    height: 130px;
    font-size: 11px;
  }
  .closing {
    padding-block: 85px 100px;
  }
  .closing h2 {
    font-size: 66px;
  }
  .closing-flower {
    position: absolute;
    right: 7%;
    top: 60px;
    font-size: 75px;
    transform: rotate(15deg);
  }
}
@media (min-width: 1000px) {
  .hero {
    gap: 65px;
  }
  .hero-stage {
    height: 480px;
  }
  .hero-stage .paper h3 {
    font-size: 42px;
  }
  .hero-stage .paper {
    padding: 30px;
  }
  .hero-stage .line {
    font-size: 13px;
  }
  .skin-toolbar {
    gap: 16px;
  }
  .skin-dots {
    gap: 2px;
  }
  .mock-stage {
    padding: 32px;
  }
  .beat-copy > p {
    font-size: 15px;
  }
  .signal-chip {
    padding: 18px;
  }
  .signal-chip strong {
    font-size: 32px;
  }
  .ai-question {
    min-height: 115px;
  }
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *:before,
  *:after {
    animation: none !important;
    transition: none !important;
  }
  .motion .reveal {
    opacity: 1;
    transform: none;
  }
}
</style>
